import { Content } from '../../types';

export const kohKoodContent: Content = {
  title: 'קו קוד – פנינת טבע קסומה במפרץ תאילנד',
  imageUrl: '/images/thailand/koh-kood/koh-kood-wide.jpeg',
  introduction:
    'קו קוד (המכונה גם קו קוט), הינו האי הרביעי בגודלו בתאילנד ומהווה אחד מיעדי הטבע הפראיים והבתוליים ביותר במדינה. האי ממוקם במזרח מפרץ תאילנד, סמוך לגבול הימי עם קמבודיה ומשתייך למחוז טראט. בניגוד לאיים מתויירים אחרים, קו קוד מציע חוויה שקטה ושלווה למחפשים חופשה באווירה טבעית ורגועה.',
  sections: [
    {
      title: 'נופי טבע מרהיבים וחופים בתוליים',
      content:
        'קו קוד הינו האי הדרומי ביותר מבין קבוצת האיים של מחוז טראט והינו מכוסה ברובו ביערות גשם טרופיים, מפלים מרשימים ונחלים צלולים. החופים באי ממוקמים בעיקר בצידו המזרחי והינם ידועים ביופיים הפראי, עם חול לבן, מים צלולים ושקט כמעט מוחלט. בניגוד לאיים מתויירים יותר, יד האדם כמעט ואינה ניכרת כאן – עד כדי כך שאפילו רשת Eleven 7 עדיין לא הגיעה לאי.',
      type: 'text',
    },
    {
      title: 'מתי כדאי לבקר?',
      content:
        'החודשים המומלצים ביותר לביקור בקו קוד הינם בין נובמבר לאפריל, כאשר מזג האוויר נוח יותר וכמות המשקעים נמוכה. בעונה זו ניתן ליהנות משקיעות מרהיבות, ים שקט וצמחייה ירוקה ושופעת.',
      type: 'text',
    },
    {
      title: 'דרכי הגעה לאי',
      content:
        "ההגעה לקו קוד הינה באמצעות מעבורות היוצאות ממחוז טראט. בשונה מהמעבורת לקו צ'אנג, המעבורת לקו קוד אינה מאפשרת העלאת כלי רכב ולכן כל ההתניידות באי מבוצעת באמצעים מקומיים. לטראט ניתן להגיע בטיסות פנים מתאילנד, באוטובוסים מבנגקוק או באמצעות רכב פרטי.",
      type: 'text',
    },
    {
      title: 'התניידות באי',
      content:
        'באי עצמו, ההתניידות נעשית בעיקר באמצעות קטנועים להשכרה, שהם אופציה נוחה וגמישה למטיילים עצמאיים. ניתן גם להשתמש בשירותי מוניות טנדר מקומיות (סונגטאו), המספקות תחבורה משותפת לנקודות מרכזיות באי.',
      type: 'text',
    },
    {
      title: 'אטרקציות מרכזיות באי',
      type: 'sub-headers',
      description: 'קו קוד מציע מגוון אטרקציות טבעיות ופעילויות למבקרים:',
      content: [
        {
          subtitle: 'מפלי קה לונג',
          text: "מפל מרשים ויפהפה הנמצא בלב הג'ונגל, עם בריכת מים צלולים המתאימה לשחייה.",
        },
        {
          subtitle: 'חוף אאו פראו',
          text: 'חוף מבודד עם מים צלולים וחול זהוב, מושלם לרגיעה ושנירקול.',
        },
        {
          subtitle: 'חוף טפאו',
          text: 'אחד החופים המרכזיים באי עם חול רך ונוף מרהיב.',
        },
        {
          subtitle: 'צלילה ושנירקול',
          text: 'האי מציע מספר אתרי צלילה מדהימים עם שוניות אלמוגים מרשימות ומגוון דגים טרופיים.',
        },
        {
          subtitle: 'סיורי קיאקים',
          text: 'ניתן לשכור קיאקים ולשוט לאורך הנהרות והמפרצים השקטים של האי.',
        },
        {
          subtitle: 'סיורים בכפרים המקומיים',
          text: 'ביקור בכפרים הקטנים של קו קוד מספק הצצה לאורח החיים הפשוט והמסורתי של המקומיים.',
        },
      ],
    },
    {
      title: 'שירותי תיירות ואירוח',
      content:
        'קו קוד מציע מגוון אפשרויות לינה, מהוסטלים פשוטים ועד ריזורטים מפנקים על חוף הים. המסעדות באי מציעות מאכלים תאילנדיים אותנטיים, במיוחד מאכלי ים טריים. בנוסף, ניתן למצוא שירותי עיסוי תאילנדי מסורתי, השכרת ציוד שנירקול ופעילויות נוספות להשלמת החוויה.',
      type: 'text',
    },
    {
      title: 'בשורה התחתונה',
      content:
        'בשורה התחתונה, קו קוד מתאים במיוחד למחפשים שקט, שלווה וטבע עוצר נשימה. האווירה באי רגועה מאוד, חיי הלילה כמעט ואינם קיימים והוא מהווה יעד מושלם למעדיפים להתרחק מההמולה וליהנות מחופי גן עדן ושמורת טבע לא נגועה.<br />לטעמינו האישי, קו קוד הינו האי השני ביופיו בתאילנד (אחרי קו ליפה) ואנו ממליצים בחום לבקר בו למשך מספר ימים ולחוות את הקסם הייחודי שהוא מציע.',
      type: 'text',
      isBold: true,
    },
  ],
};
